











import Vue from "vue"

export default Vue.extend({
  //@ts-ignore
  abstract: true,
  props: {
    mode: {
      type: String,
      default: function () {
        return "out-in"
      },
    },
  },
  mounted: function () {},
  methods: {
    enter: function (element: HTMLElement) {
      const width = window.getComputedStyle(element).width

      element.style.width = width
      element.style.position = "absolute"
      element.style.visibility = "hidden"
      element.style.height = "auto"

      const height = window.getComputedStyle(element).height

      element.style.width = ""
      element.style.position = ""
      element.style.visibility = ""
      element.style.height = "0"

      window.setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element: HTMLElement) {
      element.style.height = "auto"
    },
    leave(element: HTMLElement) {
      const height = window.getComputedStyle(element).height

      element.style.height = height

      setTimeout(() => {
        element.style.height = "0"
      })
    },
  },
})
